module.exports = __webpack_public_path__ + "static/media/Ryan Giesen.7f8c0918.jpg";